import { NavigateProps } from 'react-router-dom'
import { SafetyComponentBaseProps } from './SafetyComponent'
import useSecurityObject from 'src/hooks/useSecurityObject'
import { PropsWithChildren, useEffect, useState } from 'react'
import Error404 from 'src/pages/404'

interface SafetyRouteProps extends SafetyComponentBaseProps {}

export function SafetyRoute(props: PropsWithChildren<SafetyRouteProps>) {
    const {
        dictionarySecurityObject,
        hasReadPermission,
        hasWritePermission,
        hasReadWorkflowPermission,
        hasWriteWorkflowPermission
    } = useSecurityObject()

    const readPermission =
        props.permissionWorkflowCode != undefined
            ? hasReadWorkflowPermission(props.permissionWorkflowCode, props.componentName, props.objectName)
            : hasReadPermission(props.componentName, props.objectName)

    return <>{dictionarySecurityObject && (readPermission ? props.children : <Error404 />)}</>
}
